import * as _ from "lodash";

export const debounce = (func, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

export const parseDateToLocaleString = (dateTimeString = "", options) => {
  if (!!dateTimeString) {
    return new Date(dateTimeString).toLocaleString(undefined, options);
  } else {
    return null;
  }
};

export const toSentenceCase = string => {
  let sentence = string.charAt(0).toUpperCase() + string.slice(1);

  return sentence.split("_").join(" ");
};

const paramsToObject = function (entries) {
  const result = {};
  for (const [key, value] of entries) {
    result[key] = value;
  }
  return result;
};

export const urlToParamsObject = function (url) {
  return paramsToObject(new URLSearchParams(_.split(url, "?")[1]));
};
